export default class LoginToFb {
  constructor(context) {
    this.context = context;
  }

  run() {
    let appId = this.context.stores.systemConfiguration.get().fbAppId;
    let version = 'v3.3';
    let scope = 'manage_pages,pages_messaging,pages_messaging_subscriptions';

    if (this.context.stores.appFeatures.get().isEnabled('upgradeFacebookSDK')) {
      version = 'v9.0';
      scope = 'pages_manage_metadata,pages_read_user_content,pages_messaging,pages_messaging_subscriptions';
    }

    this.context.gateways.fbApi.loginToFb(appId, version, scope);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/channels/login_to_fb.js